import Slider from 'react-slick'
import 'animate.css/animate.min.css'
import { useState } from 'react'
import { useEffect } from 'react'

const TestimonialsSlider = ({ data }) => {
  const [Images, setImages] = useState([])
  useEffect(() => {
    fetch('/PackageJson/Home/Testimonials.json')
      .then(response => response.json())
      .then(data => {
        setImages(data)
      })
      .catch(error => console.error('Error loading JSON:', error))
  }, [Images])
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    pauseOnHover: true,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 3000,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }

  return (
    <div>
      <div
        className='sliderImages TestimonialsSlider'
        style={{ marginTop: '30px' }}
      >
        <Slider {...settings}>
          {Images.map((item, index) => (
            <div key={index} className='slide'>
              <div className='round-images'>
                <img
                  style={{
                    overflowClipMargin: 'unset',
                    objectPosition: 'center',
                    objectFit: 'cover',
                    width: '100%'
                  }}
                  src={item.images}
                  alt={item.title}
                />
              </div>
              <div>
                <p
                  dangerouslySetInnerHTML={{
                    __html: item.details.replace(/\n/g, '<br />')
                  }}
                ></p>
                <h5>{item.name}</h5>
                <small>{item.title}</small>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  )
}
export default TestimonialsSlider
